var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrintWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5345_4414)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33341 1.33366C3.33341 0.965469 3.63189 0.666992 4.00008 0.666992H12.0001C12.3683 0.666992 12.6667 0.965469 12.6667 1.33366V5.33366H13.3334C13.8638 5.33366 14.3726 5.54437 14.7476 5.91945C15.1227 6.29452 15.3334 6.80323 15.3334 7.33366V10.667C15.3334 11.1974 15.1227 11.7061 14.7476 12.0812C14.3726 12.4563 13.8638 12.667 13.3334 12.667H12.6667V14.667C12.6667 15.0352 12.3683 15.3337 12.0001 15.3337H4.00008C3.63189 15.3337 3.33341 15.0352 3.33341 14.667V12.667H2.66675C2.13631 12.667 1.62761 12.4563 1.25253 12.0812C0.877462 11.7061 0.666748 11.1974 0.666748 10.667V7.33366C0.666748 6.80323 0.877462 6.29452 1.25253 5.91945C1.62761 5.54437 2.13631 5.33366 2.66675 5.33366H3.33341V1.33366ZM4.66675 14.0003H11.3334V10.0003H4.66675V14.0003ZM12.6667 11.3337V9.33366C12.6667 8.96547 12.3683 8.66699 12.0001 8.66699H4.00008C3.63189 8.66699 3.33341 8.96547 3.33341 9.33366V11.3337H2.66675C2.48994 11.3337 2.32037 11.2634 2.19534 11.1384C2.07032 11.0134 2.00008 10.8438 2.00008 10.667V7.33366C2.00008 7.15685 2.07032 6.98728 2.19534 6.86225C2.32037 6.73723 2.48994 6.66699 2.66675 6.66699H13.3334C13.5102 6.66699 13.6798 6.73723 13.8048 6.86225C13.9298 6.98728 14.0001 7.15685 14.0001 7.33366V10.667C14.0001 10.8438 13.9298 11.0134 13.8048 11.1384C13.6798 11.2634 13.5102 11.3337 13.3334 11.3337H12.6667ZM11.3334 2.00033V5.33366H4.66675V2.00033H11.3334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5345_4414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrintWhite);
export default __webpack_public_path__ + "static/media/icon-print-white.92dea4f76605467952d99d7f7507aa18.svg";
export { ForwardRef as ReactComponent };